(function () {
  "use strict";

  const SELECTORS = {
    section: "[data-hero-carousel]",
    viewport: "[data-hero-viewport]",
    dots: "[data-hero-dots]",
    dot: "[data-hero-dot]",
    progress: "[data-hero-progress]",
  };

  const CIRCLE_CIRCUMFERENCE = 75.4;

  const waitForDependencies = () =>
    new Promise((resolve) => {
      const check = () => {
        if (
          typeof EmblaCarousel !== "undefined" &&
          typeof EmblaCarouselAutoplay !== "undefined"
        ) {
          resolve();
        } else {
          setTimeout(check, 50);
        }
      };
      check();
    });

  const updateDots = (dotsContainer, selectedIndex) => {
    const dots = dotsContainer.querySelectorAll(SELECTORS.dot);
    dots.forEach((dot, i) => {
      const isActive = i === selectedIndex;
      dot.setAttribute("aria-selected", String(isActive));
    });
  };

  const resetAllProgress = (dotsContainer) => {
    const circles = dotsContainer.querySelectorAll(SELECTORS.progress);
    circles.forEach((el) => {
      Object.assign(el.style, {
        transition: "none",
        strokeDashoffset: String(CIRCLE_CIRCUMFERENCE),
      });
    });
  };

  const getActiveCircle = (dotsContainer, selectedIndex) => {
    const dots = dotsContainer.querySelectorAll(SELECTORS.dot);
    const activeDot = dots[selectedIndex];
    return activeDot ? activeDot.querySelector(SELECTORS.progress) : null;
  };

  const animateProgress = (el, duration) => {
    if (!el) return;

    el.style.transition = "none";
    el.style.strokeDashoffset = String(CIRCLE_CIRCUMFERENCE);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.style.transition = `stroke-dashoffset ${duration}ms linear`;
        el.style.strokeDashoffset = "0";
      });
    });
  };

  const freezeProgress = (el) => {
    if (!el) return;
    const computed = window.getComputedStyle(el).strokeDashoffset;
    el.style.transition = "none";
    el.style.strokeDashoffset = computed;
  };

  const initializeCarousel = async (section) => {
    const viewport = section.querySelector(SELECTORS.viewport);
    const dotsContainer = section.querySelector(SELECTORS.dots);

    if (!viewport) return;

    const slides = section.querySelectorAll("[data-hero-slide]");
    if (slides.length <= 1) return;

    await waitForDependencies();

    const delaySeconds = parseInt(section.dataset.autoplayDelay, 10) || 5;
    const delayMs = delaySeconds * 1000;

    const autoplay = EmblaCarouselAutoplay({
      delay: delayMs,
      stopOnInteraction: false,
      stopOnMouseEnter: true,
    });

    const embla = EmblaCarousel(
      viewport,
      {
        loop: true,
        align: "start",
        skipSnaps: false,
        draggable: true,
      },
      [autoplay],
    );

    const autoplayApi = embla.plugins().autoplay;

    const onSelect = () => {
      if (!dotsContainer) return;
      const index = embla.selectedScrollSnap();
      updateDots(dotsContainer, index);
    };

    // Embla's autoplay always schedules a fresh full-duration timer on
    // play/resume — there is no remaining-time tracking in the plugin. So
    // every time a new timer is armed we reset the progress ring and
    // animate it from full over the full delay, which is the only way it
    // can stay in sync with the actual slide change.
    const onAutoplayTimerSet = () => {
      if (!dotsContainer) return;
      const index = embla.selectedScrollSnap();
      const el = getActiveCircle(dotsContainer, index);
      if (!el) return;

      resetAllProgress(dotsContainer);
      updateDots(dotsContainer, index);
      animateProgress(el, delayMs);
    };

    const onAutoplayStop = () => {
      if (!dotsContainer) return;
      const el = getActiveCircle(dotsContainer, embla.selectedScrollSnap());
      freezeProgress(el);
    };

    if (dotsContainer) {
      const dots = dotsContainer.querySelectorAll(SELECTORS.dot);
      dots.forEach((dot) => {
        dot.addEventListener("click", () => {
          const index = parseInt(dot.dataset.heroDot, 10);
          embla.scrollTo(index);
          if (autoplayApi && typeof autoplayApi.reset === "function") {
            autoplayApi.reset();
          }
        });
      });
    }

    embla.on("select", onSelect);
    embla.on("reInit", onSelect);
    embla.on("autoplay:timerset", onAutoplayTimerSet);
    embla.on("autoplay:stop", onAutoplayStop);

    onSelect();
    if (autoplayApi && autoplayApi.isPlaying && autoplayApi.isPlaying()) {
      onAutoplayTimerSet();
    }
  };

  const init = () => {
    document.querySelectorAll(SELECTORS.section).forEach(initializeCarousel);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
